<template>
  <v-text-field
    outlined
    v-model="emailAddressValue"
    :label=label
    validate-on-blur
    :disabled="disabled"
    :readonly="readOnly ? readOnly : false"
    :rules="[checkRequired(), validateEmail()]"
  />
</template>

<script>
export default {
  props: {
    label: String,
    emailAddress: String,
    isRequired: Boolean,
    disabled: Boolean,
    readOnly: Boolean
  },
  emits: ['emailChange'],
  data () {
    return {
      isValid: false
    }
  },
  computed: {
    emailAddressValue: {
      get () {
        return this.emailAddress
      },
      set (newValue) {
        this.$emit('emailChange', newValue)
      }
    }
  },
  methods: {
    checkRequired () {
      return this.isRequired ? (this.emailAddress && this.emailAddress !== '' ? true : `${this.label} is required`) : true
    },
    validateEmail () {
      if (!this.isRequired && (!this.emailAddress || this.emailAddress === '')) {
        return true
      } else {
        return this.emailAddress && this.emailAddress.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+/) ? true : 'Please enter a valid E-mail address'
      }
    }
  }
}
</script>
